import { render, staticRenderFns } from "./Fumigation.vue?vue&type=template&id=1581a224&"
import script from "./Fumigation.vue?vue&type=script&lang=js&"
export * from "./Fumigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports